<template>
        <span
        class="text-danger">
        <i
            class="fa fa-trash fa-lg icon-button mr-1"
            title="Excluir"
            @click.stop="confirmarExcluir()"
        ></i>
        </span>
</template>

<script>

export default {
    props: {
        pleito: {
            type: Object
        },

        servicos: {
            type: Object
        },
        
        permiteExcluir: {
            type: Boolean,
            default: () => false
        },
    },

    methods: {
        confirmarExcluir() {
            this.$swal({
                title: 'Excluir Pleito',
                html: `Confirma a <strong>EXCLUSÃO</strong> do pleito <b>${this.pleito.numeroPleito}</b>?`,
                icon: 'error',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não',
            }).then(result => {
                if (result.value) {
                    this.excluir()
                }
            })
        },

        excluir() {
            this.$store.dispatch('addRequest')
            this.servicos.excluir(this.pleito.pleitoId).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Pleito excluído com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('listarPleitos')
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },
}

</script>